export interface TipoEstado {
    name: string;
    value?: number;
    backgroundColor: string;
    color: string;
}

const TIPOS_ESTADO: TipoEstado[] = [
    { name: 'EnCurso', value: null, backgroundColor: '#00c0ef', color: '#fff' },
    { name: 'Nueva', value: 0, backgroundColor: '#00a65a', color: '#fff' },
    { name: 'Finalizada', value: 1, backgroundColor: '#d2d6de', color: '#444' },
    { name: 'PendienteAprobacion', value: 2, backgroundColor: '#9acd32', color: '#fff' },
    { name: 'Cancelada', value: 3, backgroundColor: '#000', color: '#fff'  },
    { name: 'Incidencia', value: 4, backgroundColor: '#c19f00', color: '#fff'  }
];

export class TipoEstadoFactory {

    static getTipoEstado(number?: number): TipoEstado {
        return TIPOS_ESTADO.find(tipoEstado => tipoEstado.value == number);
    }
}
